/**
 * 编辑页聚合候选 → MentionResource（纯函数，无 React Query / store 依赖）
 */
import type { EditorMentionCandidateItem } from '@/services/api/ai-conversations';
import type { MentionResource, MentionResourceType } from '@/types/mention';

function mapCandidateType(type: EditorMentionCandidateItem['type']): MentionResourceType {
  if (type === 'location') return 'location';
  return type;
}

/**
 * 将后端扁平候选映射为前端 MentionResource；tab 拆分由消费者按 type 完成。
 */
export function mapEditorMentionCandidatesToMentionResources(
  items: EditorMentionCandidateItem[]
): MentionResource[] {
  return items.map((item) => {
    const mappedType = mapCandidateType(item.type);
    const submitResourceType = (item.resourceType ?? undefined) as
      | 1
      | 2
      | 3
      | 4
      | 5
      | 6
      | 7
      | undefined;
    const elementName = (item.planName?.trim() || item.elementName?.trim() || mappedType) as string;

    return {
      type: mappedType,
      elementId: item.elementId,
      elementName,
      tagId: item.tagId ?? undefined,
      tagLabel: item.tagLabel ?? undefined,
      resourceId: item.resourceId,
      resourceUrl: item.resourceUrl ?? undefined,
      thumbnailUrl: item.thumbnailUrl || item.resourceUrl || undefined,
      mimeType: item.mimeType ?? undefined,
      source: 'storyboard-related' as const,
      submitResourceId: item.resourceId,
      submitResourceType,
      fileSize: item.fileSize ?? undefined,
      width: item.width ?? undefined,
      height: item.height ?? undefined,
      durationSeconds: item.duration ?? undefined,
      resolution: item.resolution ?? undefined,
      format: item.format ?? undefined,
      frameRate: item.frameRate ?? undefined,
      humanAssetType: item.humanAssetType ?? null,
      humanAssetStatus: item.humanAssetStatus ?? null,
      versionSeq: item.versionSeq ?? null,
    };
  });
}
